import { createContext, useContext } from 'react';

import { DataFeedColumn } from '../hooks/useColumns';

export interface TableContextState {
  columns: DataFeedColumn[];
  gridLayout: string;
}

export const panelContextDefaults: TableContextState = {
  columns: [],
  gridLayout: '',
};

export const TableContext = createContext<TableContextState>(panelContextDefaults);

export const useTableContext = () => useContext(TableContext);
